// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"bc3363d0","977":"fdea9020"}[chunkId] + ".chunk.js";
};